import { COURIER_ZONE_BY_PREFIX, COURIER_ZONE_CEILING_BY_FREIGHT_ZONE, COURIER_ZONE_EXCEPTIONS, FREIGHT_ZONE_BY_PREFIX, FREIGHT_ZONE_EXCEPTIONS, } from './shippingZones.generated.js';
export const SHIPPING_ZONES = ['N1', 'N2', 'E', 'NE', 'W1', 'W2', 'S1', 'S2', 'Central'];
/** Where despatches leave from. Bengaluru is S1. Per-vendor origins can come later. */
export const SHIPPING_ORIGIN = 'S1';
/** Our margin over the rate card. */
export const SHIPPING_MARKUP = 1.1;
/** Held at zero on purpose - see the header. 0.2 would apply the card's 20%. */
export const FUEL_SURCHARGE = 0;
/** Carton, padding and shrink-wrap, as a share of the goods' weight. */
export const PACKAGING_FACTOR = 1.1;
/**
 * Used only when a product has no weight on file. The backfill script refuses
 * to finish while any active product lacks one, so this is a guard against a
 * product created later without it, not a value anyone should rely on.
 */
export const FALLBACK_UNIT_WEIGHT_GRAMS = 100;
/** Rs per kg, origin row x destination column, exactly as on the card. */
export const DELHIVERY_RATE_CARD = {
    N1: { N1: 9.23, N2: 10.12, E: 17.08, NE: 31.37, W1: 11.76, W2: 15.18, S1: 18.98, S2: 22.01, Central: 15.18 },
    N2: { N1: 11.01, N2: 9.36, E: 19.48, NE: 34.16, W1: 14.55, W2: 16.19, S1: 21.13, S2: 23.28, Central: 16.45 },
    E: { N1: 12.78, N2: 14.42, E: 11.01, NE: 22.14, W1: 14.29, W2: 13.54, S1: 14.8, S2: 19.35, Central: 16.19 },
    NE: { N1: 19.1, N2: 26.44, E: 11.01, NE: 16.19, W1: 21.0, W2: 25.3, S1: 22.01, S2: 27.2, Central: 23.28 },
    W1: { N1: 13.03, N2: 16.45, E: 20.24, NE: 35.8, W1: 7.21, W2: 11.76, S1: 17.84, S2: 20.24, Central: 16.57 },
    W2: { N1: 14.8, N2: 17.71, E: 18.47, NE: 32.0, W1: 9.49, W2: 9.36, S1: 14.55, S2: 17.2, Central: 15.18 },
    S1: { N1: 16.7, N2: 17.96, E: 16.45, NE: 24.67, W1: 12.27, W2: 10.12, S1: 9.61, S2: 10.12, Central: 13.92 },
    S2: { N1: 19.35, N2: 23.02, E: 17.71, NE: 28.46, W1: 11.89, W2: 9.61, S1: 9.49, S2: 7.08, Central: 15.18 },
    Central: { N1: 12.27, N2: 13.79, E: 18.85, NE: 38.08, W1: 10.37, W2: 12.02, S1: 17.96, S2: 22.9, Central: 13.41 },
};
/* ------------------------------------------------------------------ *
 * PIN -> zone
 * ------------------------------------------------------------------ */
/**
 * The card's zone key (Delhivery):
 *   N1 Delhi, UP, Haryana, Rajasthan        N2 Chandigarh, Punjab, HP, Uttarakhand, J&K, Ladakh
 *   E  WB, Odisha, Bihar, Jharkhand, Chhattisgarh
 *   NE Assam, Meghalaya, Tripura, Arunachal, Mizoram, Manipur, Nagaland, Sikkim
 *   W1 Gujarat, Daman & Diu, Dadra & Nagar Haveli   W2 Maharashtra, Goa
 *   S1 AP, Telangana, Karnataka, Tamil Nadu, Puducherry   S2 Kerala   Central MP
 *
 * Mapped from India Post's PIN prefixes. Two-digit prefixes cover whole
 * circles; three-digit entries carve out the states that share a circle
 * (Uttarakhand inside UP, Chhattisgarh inside MP, Sikkim inside WB).
 * Prefixes missing here - the Andaman and Lakshadweep islands, Army Post
 * Offices - fall back to the dearest zone so a PIN we cannot place is never
 * undercharged.
 */
const ZONE_BY_PREFIX = {
    // Delhi, Haryana
    '11': 'N1', '12': 'N1', '13': 'N1',
    // Punjab, Chandigarh, Himachal, J&K, Ladakh
    '14': 'N2', '15': 'N2', '16': 'N2', '17': 'N2', '18': 'N2', '19': 'N2',
    // Uttar Pradesh, with Uttarakhand's own prefixes carved out
    '20': 'N1', '21': 'N1', '22': 'N1', '23': 'N1', '24': 'N1', '25': 'N1', '26': 'N1', '27': 'N1', '28': 'N1',
    '246': 'N2', '248': 'N2', '249': 'N2', '263': 'N2',
    // Rajasthan
    '30': 'N1', '31': 'N1', '32': 'N1', '33': 'N1', '34': 'N1',
    // Gujarat, Daman & Diu, Dadra & Nagar Haveli
    '36': 'W1', '37': 'W1', '38': 'W1', '39': 'W1',
    // Maharashtra, Goa
    '40': 'W2', '41': 'W2', '42': 'W2', '43': 'W2', '44': 'W2',
    // Madhya Pradesh, with Chhattisgarh carved out
    '45': 'Central', '46': 'Central', '47': 'Central', '48': 'Central', '49': 'E',
    // Telangana, Andhra Pradesh, Karnataka, Tamil Nadu, Puducherry
    '50': 'S1', '51': 'S1', '52': 'S1', '53': 'S1',
    '56': 'S1', '57': 'S1', '58': 'S1', '59': 'S1',
    '60': 'S1', '61': 'S1', '62': 'S1', '63': 'S1', '64': 'S1',
    // Kerala (Lakshadweep, 6825xx, falls through to the fallback)
    '67': 'S2', '68': 'S2', '69': 'S2',
    // West Bengal, with Sikkim carved out; Andaman (744) falls through
    '70': 'E', '71': 'E', '72': 'E', '73': 'E', '74': 'E', '737': 'NE',
    // Odisha
    '75': 'E', '76': 'E', '77': 'E',
    // Assam and the North-East
    '78': 'NE', '79': 'NE',
    // Bihar, Jharkhand
    '80': 'E', '81': 'E', '82': 'E', '83': 'E', '84': 'E', '85': 'E',
};
/** Island and service prefixes that must not inherit their circle's zone. */
const UNZONED_PREFIXES = ['744', '6825'];
/** Where a PIN we cannot place is charged to. NE is the dearest from every origin but Central. */
export const FALLBACK_ZONE = 'NE';
/**
 * PIN -> zone from Atlasship's own answers first (shippingZones.generated.ts),
 * then the India Post prefixes above for anything they were not asked about.
 */
export function pincodeToZone(pincode) {
    const pin = pincode.trim();
    if (!/^[1-9][0-9]{5}$/.test(pin))
        return { zone: FALLBACK_ZONE, matched: false };
    if (UNZONED_PREFIXES.some((p) => pin.startsWith(p)))
        return { zone: FALLBACK_ZONE, matched: false };
    const zone = exceptionZone(FREIGHT_ZONE_EXCEPTIONS, pin) ??
        FREIGHT_ZONE_BY_PREFIX[pin.slice(0, 3)] ??
        ZONE_BY_PREFIX[pin.slice(0, 3)] ??
        ZONE_BY_PREFIX[pin.slice(0, 2)];
    return zone ? { zone, matched: true } : { zone: FALLBACK_ZONE, matched: false };
}
/** Exceptions are stored as concatenated 6-digit PINs per zone; indexed on first use. */
const exceptionIndex = new Map();
function exceptionZone(table, pin) {
    let index = exceptionIndex.get(table);
    if (!index) {
        index = new Map();
        for (const [zone, pins] of Object.entries(table)) {
            for (let i = 0; i < pins.length; i += 6)
                index.set(pins.slice(i, i + 6), zone);
        }
        exceptionIndex.set(table, index);
    }
    return index.get(pin);
}
/** Cheapest to dearest - every row of the card rises in this order. */
export const COURIER_ZONES = ['A', 'B', 'C1', 'C2', 'D1', 'D2', 'E', 'F'];
/** B2C Platinum, Surface Gold, exactly as on the card. Before GST. */
export const COURIER_RATE_CARD = {
    A: { first250: 44, next250: 11, per500To5kg: 16, perKgOver5kg: 25 },
    B: { first250: 50, next250: 11, per500To5kg: 23, perKgOver5kg: 33 },
    C1: { first250: 51, next250: 16, per500To5kg: 30, perKgOver5kg: 48 },
    C2: { first250: 53, next250: 17, per500To5kg: 37, perKgOver5kg: 58 },
    D1: { first250: 54, next250: 16, per500To5kg: 37, perKgOver5kg: 62 },
    D2: { first250: 56, next250: 17, per500To5kg: 42, perKgOver5kg: 65 },
    E: { first250: 67, next250: 19, per500To5kg: 51, perKgOver5kg: 75 },
    F: { first250: 75, next250: 20, per500To5kg: 58, perKgOver5kg: 82 },
};
/** The card's rates are before GST; the carrier's invoice adds it. */
export const COURIER_GST = 0.18;
/** The freight card cannot bill a consignment for less than this. */
export const FREIGHT_MIN_KG = 20;
/** Where a PIN Atlasship has no zone for is charged to, so it is never undercharged. */
export const FALLBACK_COURIER_ZONE = 'F';
/**
 * Courier zone FROM BENGALURU (pickup 560076), as Atlasship's zone API
 * answered it on 13-14 Oct 2026 - see shippingZones.generated.ts and
 * scripts/shipping/. A prefix carries the dearest zone seen in it; PINs in a
 * cheaper zone are listed one by one. Re-run those scripts if the pickup moves.
 */
export function pincodeToCourierZone(pincode) {
    const pin = pincode.trim();
    if (!/^[1-9][0-9]{5}$/.test(pin))
        return { zone: FALLBACK_COURIER_ZONE, matched: false };
    const zone = (exceptionZone(COURIER_ZONE_EXCEPTIONS, pin) ?? COURIER_ZONE_BY_PREFIX[pin.slice(0, 3)]);
    return zone ? { zone, matched: true } : { zone: FALLBACK_COURIER_ZONE, matched: false };
}
/**
 * The dearest courier zone found anywhere in each freight zone's states. Used
 * where a rate has to be quoted for a whole state without a PIN - structured
 * data, the admin preview - so the figure shown is never below the charge.
 */
export const COURIER_ZONE_CEILING = Object.fromEntries(SHIPPING_ZONES.map((z) => [z, COURIER_ZONE_CEILING_BY_FREIGHT_ZONE[z] ?? FALLBACK_COURIER_ZONE]));
/** Rs before GST for a parcel of this weight, by the card's slabs. */
export function courierFreight(grams, zone) {
    if (!(grams > 0))
        return 0;
    const r = COURIER_RATE_CARD[zone];
    // Whole grams, so a float a hair over a slab edge does not buy the next slab.
    const g = Math.round(grams);
    if (g <= 250)
        return r.first250;
    if (g <= 500)
        return r.first250 + r.next250;
    if (g <= 5000)
        return r.first250 + r.next250 + Math.ceil((g - 500) / 500) * r.per500To5kg;
    return r.first250 + r.next250 + 9 * r.per500To5kg + Math.ceil((g - 5000) / 1000) * r.perKgOver5kg;
}
function selectedValues(product, selected) {
    const out = [];
    for (const sel of selected) {
        const group = product.optionGroups?.find((g) => g.id === sel.groupId);
        const value = group?.values?.find((v) => v.id === sel.valueId);
        if (value)
            out.push(value);
    }
    return out;
}
/** Trim after every chosen option's printSpecOverride, as the print path sees it. */
function effectiveTrim(product, selected) {
    let { trimWidthMm, trimHeightMm } = product.printSpec;
    for (const v of selectedValues(product, selected)) {
        if (v.printSpecOverride?.trimWidthMm)
            trimWidthMm = v.printSpecOverride.trimWidthMm;
        if (v.printSpecOverride?.trimHeightMm)
            trimHeightMm = v.printSpecOverride.trimHeightMm;
    }
    return { trimWidthMm, trimHeightMm };
}
export function unitWeight(input) {
    const { product, selected, sizeWmm, sizeHmm } = input;
    if (product.isService)
        return { grams: 0, volumetricGrams: 0, estimated: false };
    let gsm = product.shipping?.gsm;
    let fixed = product.shipping?.unitWeightGrams;
    let volumetric = product.shipping?.volumetricGramsPerUnit ?? 0;
    for (const v of selectedValues(product, selected)) {
        const o = v.shippingOverride;
        if (!o)
            continue;
        if (o.gsm) {
            gsm = o.gsm;
            fixed = undefined;
        }
        if (o.unitWeightGrams) {
            fixed = o.unitWeightGrams;
            gsm = undefined;
        }
        if (o.volumetricGramsPerUnit)
            volumetric = o.volumetricGramsPerUnit;
    }
    if (gsm) {
        // Area-priced products ship the size the customer chose, not the base.
        const useChosen = product.customSize && sizeWmm && sizeHmm;
        const trim = useChosen ? { trimWidthMm: sizeWmm, trimHeightMm: sizeHmm } : effectiveTrim(product, selected);
        const areaM2 = (trim.trimWidthMm * trim.trimHeightMm) / 1_000_000;
        if (areaM2 > 0)
            return { grams: gsm * areaM2, volumetricGrams: volumetric, estimated: false };
    }
    if (fixed)
        return { grams: fixed, volumetricGrams: volumetric, estimated: false };
    return { grams: FALLBACK_UNIT_WEIGHT_GRAMS, volumetricGrams: volumetric, estimated: true };
}
export function lineWeight(input) {
    const unit = unitWeight(input);
    const qty = Math.max(0, input.qty);
    return {
        deadGrams: unit.grams * qty * PACKAGING_FACTOR,
        volumetricGrams: unit.volumetricGrams * qty,
        estimated: unit.estimated,
    };
}
/* ------------------------------------------------------------------ *
 * The charge
 * ------------------------------------------------------------------ */
/**
 * The states in each zone as ISO 3166-2:IN subdivision codes (without the
 * "IN-" prefix), for structured data that must name where a rate applies.
 * The islands (AN, LD) are charged as NE - see FALLBACK_ZONE.
 */
export const ZONE_REGIONS = {
    N1: ['DL', 'UP', 'HR', 'RJ'],
    N2: ['CH', 'PB', 'HP', 'UT', 'JK', 'LA'],
    E: ['WB', 'OR', 'BR', 'JH', 'CT'],
    NE: ['AS', 'ML', 'TR', 'AR', 'MZ', 'MN', 'NL', 'SK', 'AN', 'LD'],
    W1: ['GJ', 'DH'],
    W2: ['MH', 'GA'],
    S1: ['AP', 'TG', 'KA', 'TN', 'PY'],
    S2: ['KL'],
    Central: ['MP'],
};
/** The lower of the two cards for this weight - see the header. Whole rupees, no minimum charge. */
function charge(grams, courierZone, zone, origin) {
    if (!(grams > 0))
        return { service: 'courier', carrierFreight: 0, shippingMinor: 0 };
    const courierFreightRs = courierFreight(grams, courierZone);
    const courierRs = courierFreightRs * (1 + COURIER_GST) * SHIPPING_MARKUP;
    const freightRs = DELHIVERY_RATE_CARD[origin][zone] * (1 + FUEL_SURCHARGE) * Math.max(grams / 1000, FREIGHT_MIN_KG);
    const freightChargeRs = freightRs * SHIPPING_MARKUP;
    return courierRs <= freightChargeRs
        ? { service: 'courier', carrierFreight: courierFreightRs, shippingMinor: Math.round(courierRs) * 100 }
        : { service: 'freight', carrierFreight: Math.round(freightRs * 100) / 100, shippingMinor: Math.round(freightChargeRs) * 100 };
}
function chargeableGrams(lines) {
    const dead = lines.reduce((s, l) => s + l.deadGrams, 0);
    const volumetric = lines.reduce((s, l) => s + l.volumetricGrams, 0);
    return Math.max(dead, volumetric);
}
/**
 * The charge for some weight to a freight zone, without a PIN. Courier zones
 * vary inside a state, so this prices the dearest one there: it is never below
 * what shippingQuote charges a PIN in that zone, and equals it outside the
 * nearer districts and the metros.
 */
export function shippingMinorForZone(lines, zone, origin = SHIPPING_ORIGIN) {
    return charge(chargeableGrams(lines), COURIER_ZONE_CEILING[zone], zone, origin).shippingMinor;
}
export function shippingQuote(lines, pincode, origin = SHIPPING_ORIGIN) {
    const { zone, matched } = pincodeToZone(pincode);
    const courier = pincodeToCourierZone(pincode);
    const grams = chargeableGrams(lines);
    const c = charge(grams, courier.zone, zone, origin);
    return {
        zone,
        zoneMatched: matched,
        origin,
        chargeableKg: Math.round(grams) / 1000,
        ratePerKg: DELHIVERY_RATE_CARD[origin][zone],
        markup: SHIPPING_MARKUP,
        shippingMinor: c.shippingMinor,
        estimated: lines.some((l) => l.estimated),
        service: c.service,
        courierZone: courier.zone,
        carrierFreight: c.carrierFreight,
    };
}
//# sourceMappingURL=shipping.js.map